import { render } from "./GeoPointPopover.vue?vue&type=template&id=a38e00f2&ts=true"
import script from "./GeoPointPopover.vue?vue&type=script&lang=ts"
export * from "./GeoPointPopover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__